import { CourseHeaderCombinedProps } from './types';

const usePresenter = (props: CourseHeaderCombinedProps): CourseHeaderCombinedProps => {
  return props;
};

export default usePresenter;
